// extracted by mini-css-extract-plugin
module.exports = {"messageSupport":"MessageSupport_messageSupport__1YRsD"};